import { render, staticRenderFns } from "./CustomTour.vue?vue&type=template&id=e313851a&scoped=true&"
import script from "./CustomTour.vue?vue&type=script&lang=js&"
export * from "./CustomTour.vue?vue&type=script&lang=js&"
import style0 from "./CustomTour.vue?vue&type=style&index=0&id=e313851a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e313851a",
  null
  
)

export default component.exports